import { render, staticRenderFns } from "./TableBox.vue?vue&type=template&id=5a6f9dc0&scoped=true"
import script from "./TableBox.vue?vue&type=script&lang=js"
export * from "./TableBox.vue?vue&type=script&lang=js"
import style0 from "./TableBox.vue?vue&type=style&index=0&id=5a6f9dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f9dc0",
  null
  
)

export default component.exports